import { render, staticRenderFns } from "./GlobalCommentActivator.vue?vue&type=template&id=7a7d3ab8"
import script from "./GlobalCommentActivator.vue?vue&type=script&lang=ts"
export * from "./GlobalCommentActivator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports